import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { optimumTVData } from 'src/components/template/compare/components/data/optimumData'

export default (props) => <CompareTemplate location={props.location} data={optimumTVData} />
